module.exports = __webpack_public_path__ + "static/media/carousel-leaf-img@2x.0e3e0518.png";